import NotFoundPage from "../pages/404";

export default NotFoundPage;
